import React from "react";
import Logo from "./assets/logo.svg";
import styles from "./PageHeader.module.styl";
import AuthApiClient from "api/AuthApiClient";
import { useHistory, useLocation } from "react-router";
import { useListAvailableTenants } from "hooks/tenants";

export function PageHeader({ enableLogout }) {
    const history = useHistory();
    const location = useLocation();

    const { data } = useListAvailableTenants();

    const isOrganizationSelectVisible = data?.tenantInfos.length > 0 ?? false;
    const handleLogout = async () => {
        const response = await AuthApiClient.oidcLogout();
        window.location.replace(response.logoutUrl);
    };

    const handleChangeOrganization = () => history.push("/organizations");

    return (
        <header className={styles.header}>
            <div className={styles.headerPanel}>
                <div className={styles.logoPanel}>
                    <img className={styles.logo} src={Logo} alt=" " />
                </div>
                {enableLogout && (
                    <div>
                        {isOrganizationSelectVisible && location.pathname !== "/organizations" && (
                            <button
                                data-test-name="change_organization"
                                className={styles.logout}
                                onClick={handleChangeOrganization}
                            >
                                Выбрать организацию
                            </button>
                        )}
                        <button
                            data-test-name="logout_button"
                            className={styles.logout}
                            onClick={handleLogout}
                        >
                            Выход
                        </button>
                    </div>
                )}
            </div>
        </header>
    );
}
